import createXHRPromise from 'common/utils/createXHRPromise';
import { env } from 'src/config/env';

export const versionUrl = () => {
  const baseUrl = env.ROUTE_BASEPATH === '/' ? '' : env.ROUTE_BASEPATH;
  return `${baseUrl}/public/version.json`;
};

export default function fetchCurrentAppVersion() {
  return () => {
    const request = createXHRPromise(versionUrl());

    function onSuccess(payload) {
      return payload;
    }

    function onError() {
      return {};
    }

    return request.then(onSuccess, onError);
  };
}
